import React, { useEffect, useState } from 'react'
import { Api } from '../../../useFetch'

const NotificationBar = props => {
    const [notification, setNotification] = Api({
        method: 'get',
        url: '/api/notification-bar'
    })

    const [notificationHidden, setNotificationHidden] = useState(false)
    const hideNotification = (id) => {
        localStorage.setItem(`notification${id}`, true)
        setNotificationHidden(true)
    }

    const copyCode = text => {
        navigator.clipboard.writeText(text)
    }

    useEffect(() => {
        setNotification()
    }, [])

    useEffect(() => {
        if (notification?.data?.notification) {
            const hidden = localStorage.getItem(`notification${notification.data.notification.id}`) || false
            setNotificationHidden(hidden)
        }


    }, [notification, notificationHidden])

    return notification?.data?.notification && !notificationHidden ? (
        <div className='notification-bar' style={{ background: notification.data.notification.color }}>
            <div className='container'>
                <div className='row position-relative align-items-center'>
                    <div className='col-12 col-md-3'>
                        <img className="img-fluid" src={`/uploads/${notification.data.notification.image}`} alt={notification.data.notification.image_alt} />
                    </div>
                    <div className='col-12 col-md-6'>
                        <span data-nosnippet className='notification-bar__content' dangerouslySetInnerHTML={{ __html: notification.data.notification.content }}></span>
                    </div>
                    <div className='col-12 col-md-3'>
                        {(new RegExp('^(http|https):\/\/.+')).test(notification.data.notification.link) ? (
                            <a className='notification-bar__link btn btn-white btn-transparent' href={notification.data.notification.link} target="__blank">Kontynuuj</a>
                        ) : (
                            <button className='notification-bar__link btn btn-white btn-transparent btn-dashed' title="Kliknij aby skopiować zawartość">
                                <span id='copyCode' onClick={() => copyCode(notification.data.notification.link)}>{notification.data.notification.link}</span>
                                <span className='ml-2 icon-popup'></span>
                            </button>
                        )}
                    </div>
                    <button className='notification-bar__close' onClick={() => hideNotification(notification.data.notification.id)} aria-label="Zamknij powiadomienie">
                        <span className='icon-cancel-circled-outline'></span>
                    </button>
                </div>
            </div>
        </div>
    ) : null
}

export default NotificationBar
